import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
import { __rest as e } from "../_virtual/_tslib.js";
import { jsxs as n, jsx as t } from "react/jsx-runtime";
import { BadgeIndicator as o } from "@vds-core/badges";
import { calculateRem as i, withVDSManager as r, hexToRgba as a, generateUUID as s } from "@vds-core/utilities";
import { AccessibilityTokens as l } from "@vds-tokens/accessibility";
import { ColorTokens as c } from "@vds-tokens/color";
import { ComponentTokens as d } from "@vds-tokens/component";
import { Component as u } from "react";
import p, { css as h } from "styled-components";
import f from "../util/badgeIndictorOffSetConfig.js";
var g = l.focusring.space.offset.value,
  b = l.focusring.borderwidth.value,
  $ = l.focusring.borderstyle.value,
  v = function v(e, n, t) {
    var o = e.length > 0 && !["large", "small"].includes(e);
    var r = i(o ? parseInt(e, 10) : "small" === e ? 32 : 44);
    return t && "ghost" === n && (r = i(o ? parseInt(e, 10) : "small" === e ? 20 : 24)), r;
  },
  m = function m(e) {
    var n = e.disabled,
      t = e.kind,
      o = e.surface,
      i = e.surfaceType;
    return "highContrast" === t ? c.elements.primary.inverse["on".concat(o)].value : n ? "lowContrast" === t && "colorFill" === i ? d.buttonicon.elements.lowcontrast.disabled["on".concat(o)].value : c.interactive.disabled["on".concat(o)].value : ["ghost", "lowContrast"].includes(t) ? c.elements.primary["on".concat(o)].value : void 0;
  },
  k = function k(e, n) {
    return ["ghost", "lowContrast"].includes(e) ? "light" === n ? c.elements.brandhighlight.value : c.elements.primary.ondark.value : "dark" === n ? c.elements.brandhighlight.value : c.elements.primary.ondark.value;
  },
  x = function x(e, n) {
    return "ghost" === e ? "small" === n ? "medium" : "large" : "small" === n ? "small" : "medium";
  },
  y = function y(e, n, t, o, r) {
    var a;
    !(r.length > 0 && !["large", "small"].includes(r)) && o && "ghost" === t && (a = "small" === r ? 12 : 20);
    var s = a ? "calc(100% + ".concat(i(2 * parseInt(g, 10)), " + ").concat(i(a), ")") : "calc(100% + ".concat(i(2 * parseInt(g, 10)), ")"),
      l = a ? "calc(100% - ".concat(i(2 * parseInt("1px", 10)), " + ").concat(i(a), ")") : "calc(100% - ".concat(i(2 * parseInt("1px", 10)), ")");
    return "inside" === e || n && "ghost" !== t ? l : s;
  },
  I = function I(e, n, t) {
    var o = 1;
    return !(t.length > 0 && !["large", "small"].includes(t)) && n && "ghost" === e && (o = "small" === t ? 7 : 11), o;
  },
  w = function w(e, n, t, o, i) {
    var r = "";
    switch (e) {
      case "ghost":
        r = d.buttonicon.background.semitransparent["on".concat(t)].value;
        break;
      case "lowContrast":
        r = n ? d.buttonicon.background.lowcontrast.floating["on".concat(t)].value : "media" === o ? c.elements.lowcontrast["on".concat(t)].value : d.buttonicon.background.semitransparent["on".concat(t)].value;
        break;
      case "highContrast":
        r = n ? i ? c.interactive.active["on".concat(t)].value : d.buttonicon.background.highcontrast.floating["on".concat(t)].value : i ? c.interactive.active["on".concat(t)].value : c.elements.primary["on".concat(t)].value;
        break;
      default:
        return null;
    }
    return r;
  },
  C = h(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0px;\n  margin: 0px;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  box-sizing: border-box;\n  text-align: center;\n  text-decoration: none;\n  position: relative;\n  touch-action: ", ";\n  pointer-events: auto; // To ensure proper functions when used on TileContainer\n  pointer-events: ", ";\n  vertical-align: middle;\n  outline: none;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  border-radius: 50%;\n  border: ", ";\n  ", ";\n\n  ", ";\n  ", ";\n"])), function (_ref) {
    var e = _ref.disabled;
    return e ? "none" : "manipulation";
  }, function (_ref2) {
    var e = _ref2.disabled;
    return e && "none";
  }, function (_ref3) {
    var e = _ref3.kind,
      n = _ref3.surface,
      t = _ref3.$surfaceType,
      o = _ref3.$floating;
    return function (e, n, t, o) {
      var i;
      switch (e) {
        case "ghost":
          i = "transparent";
          break;
        case "lowContrast":
          "colorFill" === t ? i = o ? d.buttonicon.background.lowcontrast.floating["on".concat(n)].value : d.buttonicon.background.semitransparent["on".concat(n)].value : "media" === t && (i = o ? d.buttonicon.background.lowcontrast.floating["on".concat(n)].value : c.background.primary["".concat(n)].value);
          break;
        case "highContrast":
          i = o ? d.buttonicon.background.highcontrast.floating["on".concat(n)].value : c.background.primary.inverse[n].value;
          break;
        default:
          return null;
      }
      return i;
    }(e, n, t, o);
  }, function (_ref4) {
    var e = _ref4.kind,
      n = _ref4.surface,
      t = _ref4.$surfaceType,
      o = _ref4.$floating,
      r = _ref4.$hideBorder;
    return function (e, n, t, o, r) {
      var a = "none";
      return r || "lowContrast" !== e || "media" !== t || o || (a = "".concat(i(1), " solid ").concat(c.elements.lowcontrast["on".concat(n)].value)), a;
    }(e, n, t, o, r);
  }, function (_ref5) {
    var e = _ref5.kind,
      n = _ref5.$floating,
      t = _ref5.surface;
    return "ghost" !== e && n && "\n      &:not(:hover)::after {\n        content: '';\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        margin: -1px;\n        box-shadow: ".concat(function (e, n) {
      var t = "0px 1px 10px ".concat(a(c.palette.black.value, .12), ", 0px 2px 4px ").concat(a(c.palette.black.value, .05), ";");
      return ("lowContrast" === e && "dark" === n || "highContrast" === e && "light" === n) && (t = "0px 1px 12px ".concat(a(c.palette.black.value, .22), ", 0px 2px 6px ").concat(a(c.palette.black.value, .15), ";")), t;
    }(e, t), ";\n        border-radius: 50%;\n        z-index: -1;\n      }\n\n      &:hover::after {\n        content: '';\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        margin: -1px;\n        box-shadow: ").concat(function (e, n) {
      var t = "0px 1px 11px ".concat(a(c.palette.black.value, .12), ", 0px 3px 5px ").concat(a(c.palette.black.value, .05));
      return ("lowContrast" === e && "dark" === n || "highContrast" === e && "light" === n) && (t = "0px 1px 13px ".concat(a(c.palette.black.value, .22), ", 0px 3px 7px ").concat(a(c.palette.black.value, .15))), t;
    }(e, t), ";\n        border-radius: 50%;\n        z-index: -1;\n      }\n    ");
  }, function (_ref6) {
    var e = _ref6.disabled,
      n = _ref6.surface,
      t = _ref6.kind,
      o = _ref6.$focusBorderPosition,
      r = _ref6.$floating,
      a = _ref6.$surfaceType,
      s = _ref6.fitToIcon,
      u = _ref6.size,
      p = _ref6.$selectable;
    return !e && " \n      ".concat(p ? "&:focus-within:not(:hover)" : "&:focus:not(:hover)", " {\n        outline: none;\n        &::before {\n            content: '';\n            ").concat("inside" === o || r && "ghost" !== t ? "box-sizing: border-box;" : "", "\n            border: ").concat(i(b), " ").concat($, " \n            ").concat(l.color.focusring["highContrast" === t && "inside" === o && "light" === n ? "ondark" : "highContrast" === t && "inside" === o && "dark" === n || "highContrast" === t && r && "dark" === n ? "onlight" : "highContrast" === t && r && "light" === n ? "ondark" : "on".concat(n)].value, ";\n            border-radius: 50%;\n            position: absolute;\n            width: ").concat(y(o, r, t, s, u), ";\n            height: ").concat(y(o, r, t, s, u), ";\n           \n          }\n        &:focus:not(:focus-visible) {\n            &::before { border: none  }\n          }\n      }\n      &:hover {\n        outline: none;\n        box-shadow: 0 0 0 ").concat(i("".concat(I(t, s, u))), " ").concat(w(t, r, n, a, !1), ";\n        ").concat("ghost" === t ? "background-color: ".concat(d.buttonicon.background.semitransparent["on".concat(n)].value) : "", ";\n      };\n      &:hover:active {\n          box-shadow: 0 0 0 ").concat(i("".concat(I(t, s, u))), " ").concat(w(t, r, n, a, !0), ";\n        };\n      \n        -webkit-background-clip: padding-box; /* for Safari */\n        background-clip: padding-box; /* for IE9+, Firefox 4+, Opera, Chrome */\n        transition: ease-out 0.1s;\n\n      &:active {\n          ").concat("highContrast" === t ? "\n                  background-color:  ".concat(c.interactive.active["on".concat(n)].value, ";\n              ") : "", "\n\n          svg path, svg polygon { fill: ").concat("highContrast" === t ? c.elements.primary["on" + ("dark" === n ? "light" : "dark")].value : c.interactive.active["on".concat(n)].value, "; \n            }\n      }\n      &:focus:active:not(:hover) {box-shadow: none;}\n    ");
  }, function (_ref7) {
    var e = _ref7.disabled,
      n = _ref7.kind,
      t = _ref7.surface;
    return e && "\n  ".concat("highContrast" === n ? "\n        background-color: ".concat(c.interactive.disabled["on".concat(t)].value, ";\n      ") : "", "\n   ");
  }),
  T = p.span.withConfig({
    displayName: "ButtonIconContainer",
    componentId: "VDS__sc-1tkw8xt-0"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  width: ", ";\n  height: ", ";\n  ", ";\n"])), function (_ref8) {
    var e = _ref8.size,
      n = _ref8.kind,
      t = _ref8.$fitToIcon;
    return v(e, n, t);
  }, function (_ref9) {
    var e = _ref9.size,
      n = _ref9.kind,
      t = _ref9.$fitToIcon;
    return v(e, n, t);
  }, function (_ref0) {
    var e = _ref0.$floating;
    return e ? "z-index: 0" : "";
  }),
  _ = p.span.withConfig({
    displayName: "BadgeIndicatorContainer",
    componentId: "VDS__sc-1tkw8xt-1"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  height: ", ";\n  width: ", ";\n  ", ";\n  display: flex;\n  justify-content: ", ";\n"])), function (_ref1) {
    var e = _ref1.size;
    return i(e);
  }, function (_ref10) {
    var e = _ref10.size;
    return i(e);
  }, function (_ref11) {
    var e = _ref11.badgeIndicatorOffset;
    return "\n      left: calc(50% + ".concat(e && (0 === e.x || "0" === e.x ? "0px" : i(e.x)), ");\n      bottom: calc(50% + ").concat(e && (0 === e.y || "0" === e.y ? "0px" : i(e.y)), ");\n    ");
  }, function (_ref12) {
    var e = _ref12.expandDirection;
    return "center" === e ? "center" : "left" === e ? "end" : "start";
  }),
  S = p.button.withConfig({
    displayName: "StyledButton",
    componentId: "VDS__sc-1tkw8xt-2"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n"])), C),
  z = p.a.withConfig({
    displayName: "StyledAnchor",
    componentId: "VDS__sc-1tkw8xt-3"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n"])), C),
  D = p.label.withConfig({
    displayName: "StyledLabel",
    componentId: "VDS__sc-1tkw8xt-4"
  })(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n"])), C),
  B = p.span.withConfig({
    displayName: "IconContainer",
    componentId: "VDS__sc-1tkw8xt-5"
  })(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", ";\n  pointer-events: none; /* pointer-events is added here to ensure the correct item is returned by the onclick handler */\n  &:focus {\n    outline: none;\n  }\n"])), function (_ref13) {
    var e = _ref13.$iconOffset;
    return "\n    left: ".concat(e && ("string" == typeof e.x ? e.x : i(e.x)), ";\n    bottom: ").concat(e && ("string" == typeof e.y ? e.y : i(e.y)));
  }),
  O = p.input.withConfig({
    displayName: "ToggleInput",
    componentId: "VDS__sc-1tkw8xt-6"
  })(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  opacity: 0;\n  margin: 0;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  pointer-events: ", "; // pointer-events: auto; To ensure proper functions when used on TileContainer\n  &:hover {\n    cursor: pointer;\n  }\n"])), function (_ref14) {
    var e = _ref14.disabled;
    return e ? "none" : "auto";
  }),
  P = p.span.withConfig({
    displayName: "HitArea",
    componentId: "VDS__sc-1tkw8xt-7"
  })(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  display: inline-block;\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  text-align: center;\n  transform: translate(-50%, -50%);\n  &:hover {\n    cursor: pointer;\n  }\n"])), i(44), i(44));
var H = /*#__PURE__*/function (_u) {
  _inherits(H, _u);
  function H(e) {
    var _this;
    _classCallCheck(this, H);
    var n;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(H).call(this, e)), n = _assertThisInitialized(_assertThisInitialized(_this)), _this._onClick = function (e) {
      e.stopPropagation();
      var t = e;
      if (t.target = e.currentTarget, n.props.onClick) return n.props.onClick(t);
    }, _this._onKeyDown = function (e) {
      var t, o;
      var i = e.keyCode;
      (13 === i || 32 === i) && e.stopPropagation(), null === (o = (t = n.props).onKeyDown) || void 0 === o || o.call(t, e);
    }, _this.handleSelect = function (e) {
      var t, o, i, r;
      e.stopPropagation();
      var a = e.keyCode,
        s = 13 === a || 32 === a;
      s && (e.preventDefault(), null === (o = (t = n.props).onKeyDown) || void 0 === o || o.call(t, e)), (a && s || !a) && (a && s && (e.target.checked = !n.state.selected), null === (r = (i = n.props).onChange) || void 0 === r || r.call(i, e, {
        name: n.props.name,
        value: n.props.value,
        selected: !n.state.selected
      }), n.isControlled || n.setState(function (e) {
        return {
          selected: !e.selected
        };
      }));
    }, _this.handleInputClick = function (e) {
      e.stopPropagation(), n.props.disabled || "click" === e.type && n.state.hovered && "undefined" != typeof document && document.activeElement instanceof HTMLElement && document.activeElement.blur();
    }, _this._renderIcon = function () {
      var _n$props = n.props,
        e = _n$props.renderIcon,
        t = _n$props.kind,
        o = _n$props.size;
      if (!e) return null;
      var i = e({
        size: x(t, o),
        color: m(n.props)
      });
      return i && i.type && ("VDS_Icon" === i.type.displayName || "svg" === i.type) ? i : null;
    }, _this._renderSelectedIcon = function () {
      var _n$props2 = n.props,
        e = _n$props2.renderSelectedIcon,
        t = _n$props2.kind,
        o = _n$props2.size,
        i = _n$props2.surface;
      if (!e) return n._renderIcon();
      var r = e({
        size: x(t, o),
        color: k(t, i)
      });
      return r && r.type && ("VDS_Icon" === r.type.displayName || "svg" === r.type) ? r : null;
    }, _this.setHoverTrue = function (e) {
      return n.setState({
        hovered: !0
      });
    }, _this.setHoverFalse = function (e) {
      return n.setState({
        hovered: !1
      });
    }, _this.state = {
      selected: _this.props.selected || !1,
      hovered: !1
    };
    return _this;
  }
  _createClass(H, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        e = _this$props.inputId,
        n = _this$props.name,
        t = _this$props.selected;
      this.isControlled = void 0 !== t, this.checkboxId = e || n || s();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e) {
      e && e.selected !== this.props.selected && this.setState(function (e) {
        return {
          selected: !e.selected
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var i = this.props,
        r = i.iconOffset,
        a = i.href,
        s = i.ariaLabel,
        l = i.tabIndex,
        c = i.disabled,
        d = i.onClick,
        u = i.onKeyDown,
        p = i.renderIcon,
        h = i.renderSelectedIcon,
        g = i.onChange,
        b = i.kind,
        $ = i.selectable,
        v = i.fitToIcon,
        m = i.size,
        k = i.surface,
        x = i.name,
        y = i.role,
        I = i.ariaHidden,
        w = i.showBadgeIndicator,
        C = i.focusBorderPosition,
        H = i.badgeIndicator,
        N = i.floating,
        V = i.surfaceType,
        j = i.hideBorder,
        K = i.buttonType,
        F = e(i, ["iconOffset", "href", "ariaLabel", "tabIndex", "disabled", "onClick", "onKeyDown", "renderIcon", "renderSelectedIcon", "onChange", "kind", "selectable", "fitToIcon", "size", "surface", "name", "role", "ariaHidden", "showBadgeIndicator", "focusBorderPosition", "badgeIndicator", "floating", "surfaceType", "hideBorder", "buttonType"]),
        L = this.state.selected,
        E = a ? z : S;
      return n(T, {
        kind: b,
        $fitToIcon: v,
        size: m,
        onMouseOver: this.setHoverTrue,
        onMouseLeave: this.setHoverFalse,
        $floating: N,
        children: [w && t(_, {
          badgeIndicatorOffset: f.getOffset(b, m, H && H.offset),
          size: function () {
            var e = H && H.padding && H.padding.vertical,
              n = {
                small: e ? 12 + 2 * parseInt(e, 10) : 16,
                medium: e ? 14 + 2 * parseInt(e, 10) : 18,
                large: e ? 16 + 2 * parseInt(e, 10) : 20,
                XLarge: e ? 20 + 2 * parseInt(e, 10) : 24,
                "2XLarge": e ? 24 + 2 * parseInt(e, 10) : 28
              };
            return H && "simple" === H.kind ? H && H.containerSize ? H.containerSize : 16 : H && "simple" === H.kind && H && H.size ? n[H.size] : 16;
          }(),
          expandDirection: H && H.expandDirection,
          children: t(o, Object.assign({
            surface: k
          }, H, {
            ariaHidden: !0,
            hideBorder: H && void 0 !== H.hideBorder ? H.hideBorder : "ghost" !== b || void 0
          }))
        }), $ ? n(D, Object.assign({}, F, {
          $focusBorderPosition: C,
          $surfaceType: V,
          kind: b,
          surface: k,
          $iconOffset: r,
          $fitToIcon: v,
          size: m,
          $hideBorder: j,
          disabled: c,
          "aria-label": s || "selectable button",
          htmlFor: this.checkboxId,
          selected: L,
          $selectable: $,
          $floating: N,
          children: [t(O, {
            "data-testid": "test-selectable",
            type: "checkbox",
            disabled: c,
            "aria-disabled": c,
            checked: L,
            "aria-checked": L,
            name: x,
            id: this.checkboxId,
            tabIndex: l || 0,
            onChange: this.handleSelect,
            onKeyDown: this.handleSelect,
            onClick: this.handleInputClick
          }), !c && t(P, {}), t(B, {
            $iconOffset: r,
            children: L ? this._renderSelectedIcon() : this._renderIcon()
          })]
        })) : n(E, Object.assign({}, F, {
          $surfaceType: V,
          $focusBorderPosition: C,
          kind: b,
          $hideBorder: j,
          surface: k,
          $iconOffset: r,
          $fitToIcon: v,
          size: m,
          href: a,
          role: y || (a ? "link" : "button"),
          disabled: c,
          tabIndex: l || 0,
          "aria-label": s,
          "aria-disabled": c,
          "aria-hidden": I,
          $selectable: $,
          $floating: N,
          onKeyDown: this._onKeyDown,
          onClick: this._onClick,
          type: a ? void 0 : K,
          children: [!c && t(P, {}), t(B, {
            $iconOffset: r,
            children: this._renderIcon()
          })]
        }))]
      });
    }
  }]);
  return H;
}(u);
H.defaultProps = {
  kind: "ghost",
  size: "large",
  surface: "light",
  surfaceType: "colorFill",
  hideBorder: !0,
  focusBorderPosition: "outside",
  floating: !1,
  disabled: !1,
  onClick: void 0,
  onChange: void 0,
  onKeyDown: void 0,
  iconOffset: {
    x: 0,
    y: 0
  },
  selectable: !1,
  fitToIcon: !1,
  ariaHidden: !1,
  showBadgeIndicator: !1,
  buttonType: "button"
};
var N = r(H);
export { N as default };